import { FC, ReactNode } from 'react';

export type UnauthenticatedLayoutLayoutProps = { children: ReactNode };

export const UnauthenticatedLayout: FC<UnauthenticatedLayoutLayoutProps> = ({
  children,
}) => (
  <div className="flex h-full flex-col items-center justify-center bg-secondary">
    {children}
  </div>
);
